import { keepUndeleted } from 'shared/domain/deletable/filters';
import { useContracts } from 'store/contract';
import { createEntityFilterInput } from '../common';
import { FieldTranslationKeys } from 'intl/keys';

export const ContractFilterInput = createEntityFilterInput({
  useData: () => {
    const { items } = useContracts();
    return items;
  },
  transformData: (contracts) =>
    contracts
      .filter(keepUndeleted)
      .map((contract) => ({ _id: contract._id, label: contract.label })),
  labelId: FieldTranslationKeys.contractNumbers,
  id: 'contract-filter',
});